import React from 'react';
import { CrmVoicemails } from '../CrmVoicemails';
import { API_BASE, authFetch } from '../../lib/rpc';

interface CrmVoicemailsTabProps {
  activeTab: 'logs' | 'chat' | 'cdr' | 'voicemails';
  isLight: boolean;
  slug?: string;
  enableVoicemails?: boolean;
  voicemailsRequirePin?: boolean;
  freepbxServerId?: string;
}

export function CrmVoicemailsTab({
  activeTab,
  isLight,
  slug,
  enableVoicemails,
  voicemailsRequirePin,
  freepbxServerId
}: CrmVoicemailsTabProps) {
  if (!enableVoicemails) return null;

  return (
    <div
      style={{
        display: activeTab === 'voicemails' ? 'flex' : 'none',
        flexDirection: 'column',
        flex: 1,
        minHeight: 0,
        width: '100%',
        background: isLight ? 'rgba(0,0,0,0.02)' : 'rgba(255,255,255,0.02)',
        border: isLight ? '1px solid rgba(0,0,0,0.1)' : '1px solid rgba(255,255,255,0.05)',
        borderRadius: '12px',
        overflow: 'hidden'
      }}
    >
      <CrmVoicemails
        slug={slug || ''}
        isLight={isLight}
        requirePin={!!voicemailsRequirePin}
        client={{
          api: {
            v1: {
              'crm-dashboard': {
                ':slug': {
                  voicemails: {
                    unlock: {
                      $post: async (opts: any) => {
                        const pw = (slug && localStorage.getItem(`crm-pw-${slug}`)) || (slug && sessionStorage.getItem(`crm-pw-${slug}`)) || '';
                        const res = await authFetch(`${API_BASE.replace(/\/$/, '')}/api/v1/crm-dashboard/${slug}/voicemails/unlock`, {
                          method: 'POST',
                          headers: { 'Content-Type': 'application/json', 'x-crm-password': pw },
                          body: JSON.stringify(opts.json)
                        });
                        return { json: () => res.json() };
                      }
                    }
                  }
                }
              }
            }
          }
        }}
        fetchVoicemailsList={async (offset = 0, limit = 50, ext = null) => {
          if (!freepbxServerId || !slug) return { voicemails: [], total: 0 };
          const pw = localStorage.getItem(`crm-pw-${slug}`) || sessionStorage.getItem(`crm-pw-${slug}`) || '';
          const url = new URL(`${API_BASE.replace(/\/$/, '')}/api/freepbx-servers/${freepbxServerId}/voicemails`);
          url.searchParams.set('offset', String(offset));
          url.searchParams.set('limit', String(limit));
          if (ext) url.searchParams.set('extension', ext);

          const res = await authFetch(url.toString(), { headers: { 'x-crm-slug': slug, 'x-crm-password': pw } });
          return res.json();
        }}
      />
    </div>
  );
}
